//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('componentAlternatives', {
//        templateUrl: 'views/components/views/componentAlternatives/componentAlternatives.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'componentAlternativesService', 'ttGridFactory', function ($stateParams, stateService, utilityService, componentAlternativesService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
//            let compKeyno = $stateParams.comp_keyno;

//            vm.model = {
//                gridReady: false,
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'componentalternatives_new',
//                    text: 'componentalternatives_new',
//                    func: () => {
//                        stateService.go('componentalternative', {
//                            prod_id: vm.model.setting.prod_keyno,
//                            comp_keyno: vm.model.setting.comp_keyno,
//                            componentalternative_keyno: '0'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await componentAlternativesService.getComponentAlternatives({
//                    prod_id: prodId,
//                    comp_keyno: compKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.grid.dataTask.saveData.parameters = vm.model.setting;

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
